import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Carousel from 'nuka-carousel';

import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { VscInfo } from 'react-icons/vsc';

import { BookingHeader } from 'components/bookingHeader';
import { Button } from 'components/common/button';
import { RoomBookButtons } from 'components/room';

import { openModal } from 'features/modalSlice';
import { setSelectedRoom } from '../../features/roomsSlice';
import {
    setAmenitiesData,
    setSelectedCancellationAndPaymentPolicyData,
} from 'features/userSlice';

import { Collapsible } from './../common/collapsible';

import { stripHTMLTags, makeStatsRequestThrottled } from '../../lib';

import './RoomDetails.css';
import {
    setSelectedFormRoom,
    setSelectedRateID,
    setSelectedRoomForm,
} from 'features/roomBookingFormSlice';
import {
    addCartItem,
    setAddingRate,
    setCartOpenState,
    setSmallCartOpenState,
    setTempRate,
} from 'features/cart/cartSlice';
import { RadioGroupCustom } from 'components/common/radioGroupCustom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { apiConfig, WIDGET_STATS_SETTINGS } from 'config';
import { RadioGroup } from 'components/common/radioGroup';

const RoomDetails = () => {
    const dispatch = useDispatch();

    const { currencySymbol } = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice
    );

    const selectedRoomIndex = useSelector(
        (state) => state.rooms.selectedRoomIndex
    );

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const rooms = useSelector((state) => state.rooms?.roomTypes) || [];
    const roomsCount = useSelector(
        (state) => state.miniBookingWidget?.data?.ourPrice?.rooms || 1
    );

    let selectedRoom = null;
    if (selectedRoomIndex !== null && selectedRoomIndex !== undefined) {
        selectedRoom = rooms[selectedRoomIndex];
    }

    const isDirect = useSelector(
        (state) => state.miniBookingWidget?.data?.bookDirectly
    );
    let noRedirect = false;
    const hasCart = useSelector(
        (state) => state.miniBookingWidget?.data?.hasCart
    );
    if (hasCart || isDirect) {
        noRedirect = true;
    }
    const cartItems = useSelector((state) => state.cart?.cartItems);
    const isAddingRate = useSelector((state) => state.cart?.isAddingRate);

    const thisRoomCartItems = cartItems.filter(
        (item) => item.roomTypeID === selectedRoom?.roomTypeID
    );
    const propCode = useSelector(
        (state) => state.miniBookingWidget?.data?.propCode
    );
    const propertyID = useSelector(
        (state) => state.miniBookingWidget?.data?.propertyID
    );
    const searchOptions = useSelector((state) => state.user);
    const cartID = useSelector(
        (state) => state.miniBookingWidget?.data?.cartID
    );
    const [selectedRate, setSelectedRate] = useState(0);
    const addToCartBack = async (cartItem) => {
        try {
            const response = await axios.post(apiConfig?.addToCartBack, {
                ...cartItem,
            });

            if (response?.data.status.toLowerCase() === 'ok') {
                return response?.data;
            } else {
                toast.error(Lang?.somethingWentWrong, {
                    autoClose: true,
                    theme: 'colored',
                    PlacementType: 'top-left',
                });
                return 'error';
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
            return 'error';
        }
    };
    const openRoomBookingForm = async (roomIndex, rateID, room) => {
        if (isAddingRate) {
            return;
        }
        if (hasCart) {
            if (room) {
                const { name, type, rates, photos, roomTypeID } = room;
                const roomName = name;
                const roomType = type;
                const price = rates.find((rate) => rate.rateID === rateID)
                    .pricing?.price;
                const prePayPrice = rates.find((rate) => rate.rateID === rateID)
                    .pricing?.prePayPrice;
                const roomPhoto = photos?.[0]?.large;
                const rateName = rates.find(
                    (rate) => rate.rateID === rateID
                ).name;

                if (cartItems.some((item) => item.roomTypeID === roomTypeID)) {
                    if (cartItems.some((item) => item.rateID === rateID)) {
                        dispatch(setCartOpenState(true));
                    } else {
                        dispatch(
                            setTempRate({
                                tempRate: rateID,
                                roomTypeID: roomTypeID,
                            })
                        );
                        dispatch(
                            openModal({
                                modalId: 'AreYouSureModal',
                            })
                        );
                    }
                } else {
                    if (!cartItems.some((item) => item.rateID === rateID)) {
                        const cartItem = {
                            rateID: rateID,
                            hotelCode: propCode,
                            roomName,
                            roomType,
                            price,
                            roomPhoto,
                            roomTypeID,
                            quantity: searchOptions?.numberOfRooms,
                            adults: searchOptions?.adults,
                            children: searchOptions?.children,
                            checkin: searchOptions?.checkInDay.date,
                            checkout: searchOptions?.checkOutDay.date,
                            cartID,
                            rateName,
                            isCompleted: false,
                            totalPrice:
                                Number(price) *
                                Number(searchOptions?.numberOfRooms),
                            extras: [],
                            prePayPrice,
                        };
                        dispatch(setAddingRate(true));
                        const response = await addToCartBack(cartItem);
                        if (response?.status === 'ok') {
                            cartItem.ID = response.ID;
                            dispatch(setSmallCartOpenState(true));
                            dispatch(addCartItem(cartItem));
                        }
                        dispatch(setAddingRate(false));
                    } else {
                        dispatch(setCartOpenState(true));
                    }
                }
            }
        } else if (isDirect) {
            dispatch(setSelectedRoomForm({ selectedRoomFormIndex: roomIndex }));
            dispatch(setSelectedRateID({ selectedRateID: rateID }));
            dispatch(setSelectedFormRoom({ room: room }));
        } else {
            makeStatsRequestThrottled(
                WIDGET_STATS_SETTINGS.actions.booknow,
                propertyID
            );
        }
    };
    const isCollapsibleOpen = true;

    const handleInfoIconClick = useCallback((data) => {
        dispatch(setSelectedCancellationAndPaymentPolicyData({ ...data }));
        dispatch(
            openModal({
                modalId: 'CancellationAndPaymentPolicyModal',
            })
        );
    }, []);

    const handleAmenitiesIconClick = useCallback((data) => {
        dispatch(setAmenitiesData({ ...data }));
        dispatch(
            openModal({
                modalId: 'AmenitiesModal',
            })
        );
    }, []);

    const closeRoomDetails = () => {
        dispatch(
            setSelectedRoom({
                selectedRoomIndex: null,
            })
        );
    };

    useEffect(() => {
        if (thisRoomCartItems && thisRoomCartItems.length > 0) {
            const cartSelectedRate = thisRoomCartItems[0].rateID;
            setSelectedRate(cartSelectedRate);
        }
    }, [thisRoomCartItems]);

    const items = selectedRoom?.rates.map((rate, index) => {
        let isInCart = false;
        let noClick = false;
        if (thisRoomCartItems && thisRoomCartItems.length > 0) {
            isInCart = cartItems?.filter((item) => item.rateID === rate.rateID);
            if (!isInCart || isInCart?.length === 0) {
                noClick = true;
            }
        }

        const isAvailable =
            rate?.availableRooms?.length > 0 &&
            rate?.memberBookNowText !== 'Not Avail';
        const notPickedClass =
            rate?.rateID === selectedRate || (index === 0 && selectedRate === 0)
                ? ''
                : 'ab-not-picked-rate';

        const label = rate?.availableRooms?.length > 0 && (
            <div
                className={`ab-room-extra-offer ${
                    !isAvailable ? 'not-available' : ''
                }`}
                key={index}
            >
                {rate?.rate && (
                    <div className="ab-room-extra-offer-name">
                        <div>
                            <div className="ab-room-offer-title">
                                {rate?.rate}
                            </div>
                            <div
                                className="ab-room-offer-notes"
                                style={{
                                    display: 'flex',
                                }}
                            >
                                {stripHTMLTags(rate.cancelationPolicy).substr(
                                    0,
                                    100
                                ) + '...'}
                                <Button
                                    className="ab-btn-info--room-details"
                                    onClick={() =>
                                        handleInfoIconClick({
                                            cancellationPolicyType:
                                                rate?.cancelationPolicyType,
                                            cancellationPolicy:
                                                rate?.cancelationPolicy,
                                            cancellationPenalty:
                                                rate?.cancelationPenalty,
                                            paymentPolicy: rate?.paymentPolicy,
                                        })
                                    }
                                    icon={
                                        <VscInfo
                                            style={{
                                                lineHeight: 'inherit',
                                                color: 'black',
                                                marginLeft: '5px',
                                                marginBottom: '-9px',
                                            }}
                                            size={17}
                                        />
                                    }
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className="ab-room-extra-offer-price">
                    <div className="ab-room-extra-offer-price-inner">
                        {rate?.pricing?.memberPrice ? (
                            <>
                                <div className="ab-room-offer-prices">
                                    <span className="ab-old-price">
                                        {roomsCount > 1 && `${roomsCount} x `}
                                        {rate.pricing.price} {currencySymbol}
                                    </span>{' '}
                                    {rate.pricing.memberPrice} {currencySymbol}
                                </div>
                                <div className="ab-room-offer-notes">
                                    {rate.pricing.saveText}{' '}
                                    <span className="ab-discount">
                                        {rate.pricing.savePrice}{' '}
                                        {currencySymbol}
                                    </span>
                                </div>
                                {rate.hasMinStay && (
                                    <div className="ab-room-upper-minstay">
                                        Min-Stay
                                    </div>
                                )}
                            </>
                        ) : !isAvailable ? (
                            <></>
                        ) : (
                            <>
                                <div className="ab-room-offer-prices">
                                    {roomsCount > 1 && `${roomsCount} x `}
                                    {rate.pricing.price} {currencySymbol}
                                </div>
                            </>
                        )}
                    </div>
                </div>
                <div className={`ab-room-extra-offer-button ${notPickedClass}`}>
                    <RoomBookButtons
                        price={rate.pricing.price}
                        currencySymbol={currencySymbol}
                        isRoomAvailable={isAvailable}
                        Lang={Lang}
                        rate={rate}
                        onClick={() =>
                            openRoomBookingForm(
                                index,
                                rate?.rateID,
                                selectedRoom
                            )
                        }
                        isDirect={isDirect}
                        noRedirect={noRedirect}
                        isLoading={isAddingRate}
                    />
                </div>
            </div>
        );

        return {
            id: rate.rateID,
            value: rate.rateID,
            label: label,
            noClick: noClick,
            room: selectedRoom,
        };
    });

    return (
        <div className="ab-room-info-page">
            <BookingHeader
                onClick={closeRoomDetails}
                title={selectedRoom?.roomInformationText}
            />

            <div className="ab-info-page-inner">
                <div className="ab-body-sidebar">
                    <div className="ab-body-sidebar-inner">
                        {selectedRoom?.popularDetails && (
                            <div className="ab-body-sidebar-section">
                                <div className="ab-section-header">
                                    <div
                                        role="button"
                                        tabIndex="0"
                                        className="ab-header-title"
                                        aria-label="Room Amenities"
                                        aria-expanded="true"
                                    >
                                        <div>
                                            {selectedRoom?.popularDetailsText}
                                        </div>
                                    </div>
                                </div>
                                <div className="ab-section-body">
                                    {selectedRoom?.popularDetails?.map(
                                        (item, index) => {
                                            return (
                                                <div
                                                    className="ab-amenities-row"
                                                    key={index}
                                                >
                                                    <label className="ab-popular-details-container">
                                                        {/* TODO: NEED AN ICON AS WELL */}
                                                        {item}
                                                    </label>
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                        )}
                        {selectedRoom?.amenities && (
                            <div className="ab-body-sidebar-section">
                                {/* TODO: COLLAPSIBLE IS NOT OPEN EVERY TIME THAT WE OPEN THE DETAIL VIEW */}
                                <Collapsible
                                    title={selectedRoom?.roomAmenitiesText}
                                    open={isCollapsibleOpen}
                                >
                                    <div className="ab-section-body ab-amenities-wrapper">
                                        {selectedRoom?.amenities.map(
                                            (amenity, index) => {
                                                return (
                                                    <div
                                                        className="ab-amenities-row"
                                                        key={index}
                                                    >
                                                        <label className="ab-amenities-checkmark-container">
                                                            {amenity}
                                                            <span className="ab-checkmark"></span>
                                                        </label>
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                </Collapsible>
                            </div>
                        )}
                    </div>
                </div>

                <div className="ab-body-main">
                    {Array.isArray(selectedRoom?.photos) &&
                        selectedRoom?.photos.length > 0 && (
                            <div className="ab-roominfo-images-container">
                                <Carousel
                                    defaultControlsConfig={{
                                        // TODO: THIS HERE THROWS A WARNING
                                        prevButtonText: (
                                            <IoIosArrowBack size={50} />
                                        ),
                                        nextButtonText: (
                                            <IoIosArrowForward size={50} />
                                        ),
                                        prevButtonClassName:
                                            'ab-image-carousel-prev-btn',
                                        nextButtonClassName:
                                            'ab-image-carousel-next-btn',
                                    }}
                                    cellSpacing={10}
                                >
                                    {selectedRoom?.photos.map(
                                        (photo, index) => {
                                            return (
                                                <img
                                                    src={photo.medium}
                                                    key={index}
                                                    style={{
                                                        width: '100%',
                                                        height: '330px',
                                                    }}
                                                />
                                            );
                                        }
                                    )}
                                </Carousel>
                            </div>
                        )}
                    {selectedRoom?.amenities && (
                        <div className="ab-room-info-mobile-ammenities-wrapper">
                            <div>{Lang.amenities}</div>
                            <Button
                                className="ab-btn-info--room-details"
                                onClick={() =>
                                    handleAmenitiesIconClick(
                                        selectedRoom?.amenities
                                    )
                                }
                                icon={
                                    <VscInfo
                                        style={{
                                            lineHeight: 'inherit',
                                            color: 'black',
                                            marginLeft: '5px',
                                            marginBottom: '-6px',
                                        }}
                                        size={17}
                                    />
                                }
                            />
                        </div>
                    )}

                    <div className="ab-roominfo-body">
                        <div className="ab-roominfo-title">
                            {selectedRoom?.name}
                        </div>
                        <div className="ab-roominfo-notes">
                            {selectedRoom?.cancellationPoliciesText}
                            <Button
                                className="ab-btn-info--room-details"
                                onClick={() =>
                                    handleInfoIconClick({
                                        cancellationPolicyType:
                                            selectedRoom?.rates[0]
                                                ?.cancelationPolicyType,
                                        cancellationPolicy:
                                            selectedRoom?.rates[0]
                                                ?.cancelationPolicy,
                                        cancellationPenalty:
                                            selectedRoom?.rates[0]
                                                ?.cancelationPenalty,
                                        paymentPolicy:
                                            selectedRoom?.rates[0]
                                                ?.paymentPolicy,
                                    })
                                }
                                icon={
                                    <VscInfo
                                        style={{
                                            lineHeight: 'inherit',
                                            color: 'inherit',
                                            marginLeft: '5px',
                                            marginTop: '-2px',
                                        }}
                                        size={17}
                                    />
                                }
                            />
                        </div>
                        <div
                            className="ab-roominfo-description"
                            dangerouslySetInnerHTML={{
                                __html: selectedRoom?.description,
                            }}
                        ></div>

                        {Array.isArray(selectedRoom?.rates) &&
                            selectedRoom?.rates.length > 0 && (
                                <div className="ab-roominfo-extra-offers">
                                    {hasCart ? (
                                        <RadioGroupCustom
                                            items={items}
                                            setSelectedRate={setSelectedRate}
                                            selectedRate={selectedRate}
                                        />
                                    ) : (
                                        <RadioGroup
                                            items={items}
                                            setSelectedRate={setSelectedRate}
                                            selectedRate={selectedRate}
                                        />
                                    )}
                                </div>
                            )}
                    </div>
                </div>
            </div>
        </div>
    );
};

RoomDetails.propTypes = {
    selectedRoomIndex: PropTypes.number,
    setSelectedRoom: PropTypes.func,
};

export default RoomDetails;
